export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";